export const getList = (response) => {
  const body = response?.data;
  const value = Array.isArray(body)
    ? body
    : body?.data || body?.results || body?.templates || body?.mappings || [];
  return Array.isArray(value) ? value : [];
};

export const getTemplateId = (item) => item?.id ?? item?.template_id;
export const getTemplateName = (item) => item?.name ?? item?.template_name ?? "";
export const getTemplateFormat = (item) => item?.format ?? item?.file_format ?? "";

export const getMappingTemplate = (mapping, templates) => {
  if (mapping?.pms_template && typeof mapping.pms_template === "object") {
    return mapping.pms_template;
  }
  const id = mapping?.pms_template ?? mapping?.pms_template_id ?? mapping?.template_id;
  return templates.find((template) => String(getTemplateId(template)) === String(id));
};

export const getMappingSchemeId = (mapping) =>
  mapping?.pms_scheme?.id ?? mapping?.pms_scheme ?? mapping?.pms_scheme_id;

export const getMappingScheme = (mapping, schemes) => {
  if (mapping?.pms_scheme && typeof mapping.pms_scheme === "object") {
    return mapping.pms_scheme;
  }
  const id = getMappingSchemeId(mapping);
  return schemes.find((item) => String(item.id) === String(id));
};

export const getSchemeLabel = (scheme) =>
  scheme?.name ?? scheme?.scheme_name ?? scheme?.code ?? scheme?.label ?? "-";

export const getMappingTemplateId = (mapping) =>
  mapping?.pms_template?.id ??
  mapping?.pms_template ??
  mapping?.pms_template_id ??
  mapping?.template_id;
